var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"toggle-btn",on:{"click":_vm.toggle}},[_c('Icon',{staticClass:"profile-icon m-auto",attrs:{"name":"mdi.account"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }